import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AuthenticationService} from '@services/authentification.service';
import {Favorite} from '@models/favorite';
import {environment} from '~/environments/environment';
import {ImageService} from '@services/image.service';

@Component({
    selector: 'app-popup',
    templateUrl: './popup.component.html',
    styleUrls: ['./popup.component.scss']
})
export class PopupComponent implements OnInit {

    favorite: Favorite;
    current = 0;
    rand = 0;
    apiUrl = environment.apiUrl;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<PopupComponent>,
        public authenticationService: AuthenticationService,
        public imageService: ImageService,
    ) {
        this.rand = Math.floor(Math.random() * 10000);
    }

    ngOnInit(): void {
        this.favorite = this.data.favorite;
        this.current = this.data.current;
    }

    onClose(redirect): void {
        this.dialogRef.close(redirect);
    }
}
